import React from 'react';
import { connect } from "react-redux";
import { Container, Row, Col, Table, Button } from 'react-bootstrap'
import PageBanner from '../common/page/PageBanner'
import Alert from '../common/modal/Alert';
import Paginator from '../common/page/Paginator'
import { getPaginatorHelper } from '../common/page/PaginatorHelper'
import Loading from '../common/modal/Loading';
import Confirmation from '../common/modal/Confirmation';
import configData from "../../config/config.json";
import axios from "axios";
import PhoneNumberSelectionList from '../common/selection/PhoneNumberSelectionList';
import { setSelectedTenantAdminType, PhoneListTenantAdminKey } from "../../redux/actions/tenantAdminActions";
import { LOADING_STATUES, ALERT_TYPES } from "../constants/constants";

const componentName = PhoneListTenantAdminKey;
export const PhoneListTenantAdminComponentName = "PhoneListTenantAdminComponentName";

const mapStateToProps = state => {

	return {
		sideNavigationOpen: state.sideNavigationReducer,
		paginationPage: state.phonesPaginationTenantAdminReducer,
		alertListFilters: state.alertListFiltersReducer,
		role: state.currentUserReducer.role
	};
}

const mapDispatchToProps = (dispatch) => {
	return {
		alertListPhoneNumberFilter: (phoneNumberId, phoneNumberName) => dispatch({ type: 'SET_ALERT_LIST_PHONE_NUMBER_FILTER', phoneNumberFilter: { phoneNumberId, phoneNumberName } }),
		setSelectedTenantAdminType: () => dispatch(setSelectedTenantAdminType(componentName))
	}
}

class PhoneList extends React.Component {

	state = {
		filteredList: [],
		filterText: '',
		selectedId: 0,
		selectedPhoneName: '',
		loadingStatus: '',
		showSendTextConfirmationDialog: false,
		showValidationConfirmationDialog: false,
		showInvalidationConfirmationDialog: false,
		showResetConfirmationDialog: false,
		showAlert: false,
		alertMessage: "",
		alertType: ALERT_TYPES.OK,
		filteringKey: 0 /*Is incremeted to re-render/mount the Paginator component */
	}

	showLoading = () => {
		if (this.state.loadingStatus === "") {
			this.setState({
				loadingStatus: LOADING_STATUES.LOADING
			})
			return true;
		}
		return false;
	}

	handleTextFilter = (filterText) => {
		this.setState({ filterText: filterText, filteringKey: this.state.filteringKey + 1  }, function () { this.handleFilter() })
	}

	handleTextFilterReset = () => {
		this.setState({ filterText: '',  filteringKey: this.state.filteringKey + 1  }, function () { this.handleFilter() })
	}

	handleFilter = () => {
		if (this.showLoading() !== true) {
			return;
		}

		let filters = { filterText: this.state.filterText };
		axios.post(configData.LANDNOTIFICATION_SERVER_URL + "tenantAdmin/phones", filters, { withCredentials: true })
			.then((response) => {
				this.setState({ filteredList: response.data.content.phones, loadingStatus: '' })
			}, (error) => {
				this.setState({ loadingStatus: '' }, this.showWarning(error.response.data.message));
			});
	}

	showAlert = (alertMessage) => {
		this.setState({
			showAlert: true,
			alertMessage
		})
	}

	showWarning = (alertMessage) => {
		this.setState({
			alertType: ALERT_TYPES.WARNING,
			showAlert: true,
			alertMessage
		})
	}

	hideAlert = () => {
		this.setState({
			showAlert: false,
			alertMessage: "",
			alertType: ALERT_TYPES.OK,
			loadingStatus: ''
		}, this.handleFilter())
	}

	handleRedirectToAlerts = (event) => {
		event.preventDefault();
		let selecteId = event.target.closest("tr").id;
		let selectedPhoneName = event.target.closest("tr").getAttribute("name");

		this.setState({ selecteId, selectedPhoneName });

		this.props.history.push('/tenantAdmin/alerts');

		this.props.alertListPhoneNumberFilter(selecteId, selectedPhoneName);
	}


	// SMS - begin  
	showSendTextConfirmation = (event) => {
		event.preventDefault();
		let selectedId = event.target.closest("tr").id;
		let selectedPhoneName = event.target.closest("tr").getAttribute("name");

		this.setState({
			selectedId,
			selectedPhoneName,
			loadingStatus: '',
			showSendTextConfirmationDialog: true
		})
	}

	hideSendTextConfirmation = () => {
		this.setState({
			loadingStatus: '',
			showSendTextConfirmationDialog: false
		})
	}

	handleConfirmTexting = (event) => {
		if (this.showLoading() === true) {
			let request = {
				id: this.state.selectedId
			};

			axios.post(configData.LANDNOTIFICATION_SERVER_URL + "tenantAdmin/helloUser", request, { withCredentials: true })
				.then(
					(response) => {
						this.setState({
							loadingStatus: '',
							alertType: ALERT_TYPES.OK
						}, this.showAlert(response.data.message));
					},
					(error) => {
						this.setState({
							loadingStatus: '',
							alertType: ALERT_TYPES.WARNING
						}, this.showAlert(error.response.data.message));
					}
				);
		}
	}
	// SMS - End

	// Valiate - Begin
	showValidationConfirmation = (event) => {
		event.preventDefault();
		let selectedId = event.target.closest("tr").id;
		let selectedPhoneName = event.target.closest("tr").getAttribute("name");

		this.setState({
			selectedId,
			selectedPhoneName,
			loadingStatus: '',
			showValidationConfirmationDialog: true
		})
	}

	hideValidationConfirmation = () => {
		this.setState({
			loadingStatus: '',
			showValidationConfirmationDialog: false
		})
	}

	handleConfirmValidation = (event) => {
		if (this.showLoading() === true) {
			let request = {
				id: this.state.selectedId
			};

			axios.post(configData.LANDNOTIFICATION_SERVER_URL + "tenantAdmin/validatePhone", request, { withCredentials: true })
				.then(
					(response) => {
						this.setState({
							loadingStatus: '',
							alertType: ALERT_TYPES.OK
						}, this.showAlert(response.data.message));
					},
					(error) => {
						this.setState({
							loadingStatus: '',
							alertType: ALERT_TYPES.WARNING
						}, this.showAlert(error.response.data.message));
					}
				);


		}
	}
	// Valiate - End

	// Invaliate - Begin
	showInvalidationConfirmation = (event) => {
		event.preventDefault();
		let selectedId = event.target.closest("tr").id;
		let selectedPhoneName = event.target.closest("tr").getAttribute("name");

		this.setState({
			selectedId,
			selectedPhoneName,
			loadingStatus: '',
			showInvalidationConfirmationDialog: true
		})
	}

	hideInvalidationConfirmation = () => {
		this.setState({
			loadingStatus: '',
			showInvalidationConfirmationDialog: false
		})
	}

	handleConfirmInvalidation = (event) => {
		if (this.showLoading() === true) {
			let request = {
				id: this.state.selectedId
			};

			axios.post(configData.LANDNOTIFICATION_SERVER_URL + "tenantAdmin/invalidatePhone", request, { withCredentials: true })
				.then(
					(response) => {
						this.setState({
							loadingStatus: '',
							alertType: ALERT_TYPES.OK
						}, this.showAlert(response.data.message));
					},
					(error) => {
						this.setState({
							loadingStatus: '',
							alertType: ALERT_TYPES.WARNING
						}, this.showAlert(error.response.data.message));
					}
				);
		}
	}
	// Invalidate - End

	// Reset - Begin
	showResetConfirmation = (event) => {
		event.preventDefault();
		let selectedId = event.target.closest("tr").id;
		let selectedPhoneName = event.target.closest("tr").getAttribute("name");

		this.setState({
			selectedId,
			selectedPhoneName,
			loadingStatus: '',
			showResetConfirmationDialog: true
		})
	}

	hideResetConfirmation = () => {
		this.setState({
			loadingStatus: '',
			showResetConfirmationDialog: false
		})
	}

	handleConfirmReset = (event) => {
		if (this.showLoading() === true) {
			let request = {
				id: this.state.selectedId
			};

			axios.post(configData.LANDNOTIFICATION_SERVER_URL + "tenantAdmin/resetPhone", request, { withCredentials: true })
				.then(
					(response) => {
						this.setState({
							loadingStatus: '',
							alertType: ALERT_TYPES.OK
						}, this.showAlert(response.data.message));
					},
					(error) => {
						this.setState({
							loadingStatus: '',
							alertType: ALERT_TYPES.WARNING
						}, this.showAlert(error.response.data.message));
					}
				);
		}
	}
	// Reset - End

	componentDidMount() {
		this.props.setSelectedTenantAdminType();
		this.handleFilter();
	}

	render() {

		let formTemplateMarginLeft = 60
		if (this.props.sideNavigationOpen) {
			formTemplateMarginLeft = 270
		}

		const numberOfVisibleRecords = 10;
		let numberOfPages = Math.ceil(this.state.filteredList.length / numberOfVisibleRecords);
		let paginationHelper = getPaginatorHelper(this.props.paginationPage, this.state.filteredList, numberOfVisibleRecords);


		const textFilterProps = {
			textFilter: this.handleTextFilter,
			textFilterReset: this.handleTextFilterReset,
			filterText: this.state.filterText
		}

		return (

			<div style={{ marginTop: 4, marginLeft: formTemplateMarginLeft, marginRight: 20, paddingBottom: 4, borderTop: '1px solid lightGray', boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.55), 0 6px 20px 0 rgba(0, 0, 0, 0.54)" }}>
				{
					(this.props.role === 'FOREVER' || this.props.role === 'TRIMIN' || this.props.role === 'TENANT') &&
					// <PageBanner pageHeading='Phones' finderFilterProps2={phoneNumberFinderFilterProps}  />
					<PageBanner pageHeading='Phones' textFilterProps={textFilterProps} />
				}
				<Container fluid="true">
					<Row>
						<Col style={{ paddingLeft: 0, paddingRight: 0, paddingBottom: 0, marginTop: 20, marginLeft: 20, marginRight: 20, border: '3px solid darkGray', borderRadius: '5px' }}>
							<Table striped hover size="sm" >
								<thead>
									<tr>
										<th style={{ width: '10%' }} scope="col">Phone</th>
										<th style={{ width: '10%' }} scope="col">Validated</th>
										<th style={{ width: '30%' }} scope="col"></th>
									</tr>
								</thead>

								<tbody>
									{
										paginationHelper.currentPageRecordList.map((phoneResult) => {
											let inactiveBadge = '';
											if (phoneResult.status === 'I') {
												inactiveBadge = "inactive";
											}
											return (
												<tr style={{ cursor: "pointer" }} id={phoneResult.id} name={phoneResult.phoneNumber} onClick={this.handleRowClick}>
													<td>{phoneResult.phoneNumberFormatted}<span className='badge badge-light'>{inactiveBadge}</span></td>
													<td>{phoneResult.validated ? "Yes" : "No"}</td>
													<td style={{ float: 'right' }}>
														<Button variant="primary" size='sm' onClick={this.handleRedirectToAlerts}>Alerts ({phoneResult.alertCount})</Button>&nbsp;
													</td>
												</tr>
											)
										})
									}
								</tbody>
							</Table>
						</Col>
					</Row>
					<Row>&nbsp;</Row>
					<Row>
						<Col style={{ marginLeft: 4 }}>Displaying Results: {paginationHelper.currentPageStartingRecordNumber}-{paginationHelper.currentPageEndingRecordNumber} of {this.state.filteredList.length}</Col>
						<Col><Paginator style={{ justifyContent: 'center' }} componentName={PhoneListTenantAdminComponentName} key={this.state.filteringKey} numberOfVisibleRecords={numberOfVisibleRecords} numberOfPages={numberOfPages} ></Paginator></Col>
					</Row>
				</Container>

				<Loading loadingIndicator={this.state.status === LOADING_STATUES.LOADING} />
				<Confirmation show={this.state.showValidationConfirmationDialog} cancelConfirmation={this.hideValidationConfirmation} proceedConfirmation={this.handleConfirmValidation} question={'Validate phone ' + this.state.selectedPhoneName + '?'} />
				<Confirmation show={this.state.showInvalidationConfirmationDialog} cancelConfirmation={this.hideInvalidationConfirmation} proceedConfirmation={this.handleConfirmInvalidation} question={'Invalidate phone ' + this.state.selectedPhoneName + '?'} />
				<Confirmation show={this.state.showSendTextConfirmationDialog} cancelConfirmation={this.hideSendTextConfirmation} proceedConfirmation={this.handleConfirmTexting} question={'Text phone ' + this.state.selectedPhoneName + '?'} />
				<Confirmation show={this.state.showResetConfirmationDialog} cancelConfirmation={this.hideResetConfirmation} proceedConfirmation={this.handleConfirmReset} question={'Reset phone ' + this.state.selectedPhoneName + '?'} />
				<PhoneNumberSelectionList showModal={this.state.showPhoneNumberList} onHide={(selectedId, selectedName) => this.handleClosePhoneNumberLookup(selectedId, selectedName)} />
				<Alert show={this.state.showAlert} hideAlert={this.hideAlert} message={this.state.alertMessage} type={this.state.alertType} />
			</div>

		)
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(PhoneList);